/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Join_To_ParticipateInputs */

const en_join_to_participate = /** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the community to participate in the discussion.`)
};

const es_join_to_participate = /** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la comunidad para participar en la discusión.`)
};

const fr_join_to_participate = /** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoignez la communauté pour participer à la discussion.`)
};

const de_join_to_participate = /** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tritt der Community bei, um an der Diskussion teilzunehmen.`)
};

const id_join_to_participate = /** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabunglah dengan komunitas untuk berpartisipasi dalam diskusi.`)
};

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const ja_join_to_participate = en_join_to_participate;

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const zh_join_to_participate = en_join_to_participate;

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const ar_join_to_participate = en_join_to_participate;

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const it_join_to_participate = en_join_to_participate;

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const ru_join_to_participate = en_join_to_participate;

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const pt_join_to_participate = en_join_to_participate;

/** @type {(inputs: Join_To_ParticipateInputs) => LocalizedString} */
const ko_join_to_participate = en_join_to_participate;

/**
* | output |
* | --- |
* | "Join the community to participate in the discussion." |
*
* @param {Join_To_ParticipateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const join_to_participate = /** @type {((inputs?: Join_To_ParticipateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_To_ParticipateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_join_to_participate(inputs)
	if (locale === "es") return es_join_to_participate(inputs)
	if (locale === "fr") return fr_join_to_participate(inputs)
	if (locale === "de") return de_join_to_participate(inputs)
	if (locale === "ja") return ja_join_to_participate(inputs)
	if (locale === "zh") return zh_join_to_participate(inputs)
	if (locale === "ar") return ar_join_to_participate(inputs)
	if (locale === "id") return id_join_to_participate(inputs)
	if (locale === "it") return it_join_to_participate(inputs)
	if (locale === "ru") return ru_join_to_participate(inputs)
	if (locale === "pt") return pt_join_to_participate(inputs)
	return ko_join_to_participate(inputs)
});